export default {
    methods: {
        downloadInvoice(invoice) {
            this.$axios({
                url: `/api/invoices/${invoice.billingo_id}/download`,
                method: 'GET',
                responseType: 'blob', // important
            })
                .then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', invoice.billingo_id + '.pdf');
                    const elem = document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(elem);
                })
                .catch(err => {
                    console.log('DOWNLOAD INVOICE ERROR', err.response);
                });
        },
    }
}
